import { render, staticRenderFns } from "./CarrosselPreVisualizacaoTemplate.vue?vue&type=template&id=862a1f0e&scoped=true&"
import script from "./CarrosselPreVisualizacaoTemplate.vue?vue&type=script&lang=js&"
export * from "./CarrosselPreVisualizacaoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CarrosselPreVisualizacaoTemplate.vue?vue&type=style&index=0&id=862a1f0e&scoped=true&lang=css&"
import style1 from "./CarrosselPreVisualizacaoTemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862a1f0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VIcon,VSpacer})
